import { useFragment as useApolloFragment } from '@apollo/client/react';

import { type ReportComponentProps } from '@modules/_shared/components/report-editor/ReportEditorContext';
import { STEP_PROPERTY_DETAILS_BROCHURE_FRAGMENT } from '@modules/reports/brochure-report/brochureReportsQueries';
import StepPropertyDetails from '@modules/reports/shared/StepPropertyDetails';
import { useUpdateListingBrochure } from '@modules/reports/shared/utils';

const StepPropertyDetailsBrochure = (props: ReportComponentProps) => {
  const { reportId: listingId } = props;
  const [updateListingBrochure, updating] = useUpdateListingBrochure(
    listingId,
    'page-property',
  );

  const { data } = useApolloFragment({
    fragment: STEP_PROPERTY_DETAILS_BROCHURE_FRAGMENT,
    fragmentName: 'StepPropertyDetailsBrochure',
    from: {
      __typename: 'lots',
      id: listingId,
    },
  });

  return (
    <StepPropertyDetails
      propertyId={data?.property?.id}
      onPropertyUpdate={() =>
        updateListingBrochure({
          updated_at: new Date().toISOString(),
        })
      }
      step={props.step}
      setStep={props.setStep}
      updating={updating}
    />
  );
};

export default StepPropertyDetailsBrochure;
